import { callApi } from '../utils/api'
import { getLocalStorageUserToken } from '../utils/localStorage'
import { endpoints } from './config'

export const deleteUser = async () => {
  const userToken = await getLocalStorageUserToken()

  if (!userToken) {
    return null
  }

  const response = await callApi({
    path: endpoints.deleteUser,
    token: userToken
  })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
